import {
  GET_PARTIES,
  GET_PARTY,
  ADD_PARTY,
  DELETE_PARTY,
  UPDATE_PARTY,
} from "../../type/parties";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTIES:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default departmentReducer;
